<script>
/**
 * 如何定义一个 route 与tab项目对应关系，也就是确定tab是否存在，唯一键值是如何计算
 * 计算来源：route.name,route.path,route.fullpath 不同的方式，不同的选择，差异会很大
 *
 */
import Sortable from 'sortablejs';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'MultiTab',
  data() {
    return {
      contextmenuList: [
        {
          icon: 'sync',
          title: this.$t('common.bt.refresh'),
          value: 'refresh',
        },
        {
          icon: 'arrow-left',
          title: this.$t('common.bt.Closeleft'),
          value: 'closeLeft',
        },
        {
          icon: 'arrow-right',
          title: this.$t('common.bt.Closeright'),
          value: 'closeRight',
        },
        {
          icon: 'close',
          title: this.$t('common.bt.Closeothers'),
          value: 'closeOther',
        },
        {
          icon: 'close-circle',
          title: this.$t('common.bt.Closerall'),
          value: 'closeAll',
        },
      ],
    };
  },
  computed: {
    ...mapState('system/page', ['opened', 'current']),
  },
  mounted() {
    this.sortTab();
  },
  methods: {
    ...mapActions('system/page', [
      'close',
      'closeLeft',
      'closeRight',
      'closeOther',
      'closeAll',
      'sortOrder',
    ]),
    sortTab() {
      // http://www.sortablejs.com/options.html
      // 拖拽排序
      Sortable.create(this.$el.querySelector('.ant-tabs-nav>div'), {
        animation: 150,
        // handle: '.ant-tabs-tab',
        // ghostClass: 'blue-background-class',
        onEnd: (evt) => {
          const { oldDraggableIndex: oldIndex, newDraggableIndex: newIndex } = evt;
          this.sortOrder({ oldIndex, newIndex });
        },
      });
    },
    onEdit(targetKey, action) {
      // const actionEmnu = {
      //   remove: 'close',
      // };
      // this[actionEmnu[action]](targetKey);
      if (action === 'remove') {
        this.close({ tabId: targetKey });
      }
    },
    onChange(activeKey) {
      // 找到点击的页面在 tabs 列表里是哪个,我们使用路由中的tabId标识，没有使用fullPath
      const route = this.opened.find((page) => page.meta.tabId === activeKey);
      const { path, params, query } = route;
      if (route) {
        this.$router.push({ path, params, query });
      }
    },

    closeMenuClick(key, tabId) {
      if (key === 'refresh') {
        // this.$router.replace('/refresh');
        this.$nextTick(() => {
          this.$router.replace('/refresh');
        });
      } else {
        this[key]({
          pageSelect: tabId,
        });
      }
    },
    renderTabPaneMenu(tabId) {
      const contextmenuList = [...this.contextmenuList];
      if (tabId !== this.current) {
        contextmenuList.shift(0);
      }

      const menuItems = contextmenuList.map((item) => (
        <a-menu-item key={item.value}>
          <a-icon type={item.icon} />
          {item.title}
        </a-menu-item>
      ));
      return (
        <a-menu
          {...{
            on: {
              click: ({ key }) => {
                this.closeMenuClick(key, tabId);
              },
            },
          }}
        >
          {menuItems}
        </a-menu>
      );
    },
    // render
    renderTabPane(meta) {
      const { title, icon, tabId } = meta;
      let tabTitle = title;
      if (icon) {
        tabTitle = <a-icon type={icon} />;
      }
      const menu = this.renderTabPaneMenu(tabId);
      return (
        <a-dropdown overlay={menu} trigger={['contextmenu']}>
          <div style={{ userSelect: 'none' }} tabId={tabId}>
            {this.$t(tabTitle)}
          </div>
        </a-dropdown>
      );
    },
  },

  render() {
    const { onEdit, onChange } = this;
    const pages = this.opened;
    const panes = pages.map((page) => (
      <a-tab-pane
        tab={this.renderTabPane(page.meta)}
        key={page.meta.tabId}
        closable={page.meta.closable}
      />
    ));
    return (
      <div class="ant-pro-multi-tab">
        <div class="ant-pro-multi-tab-wrapper">
          <a-tabs
            hideAdd
            type="editable-card"
            activeKey={this.current}
            {...{ on: { edit: onEdit, change: onChange } }}
          >
            {panes}
          </a-tabs>
        </div>
      </div>
    );
  },
  // end
};
</script>
